import { CURRENCY_MAPPER } from '../mappers/currency.mapper';
import { ICustomerContext } from '../models/context/customer.context.model';
import { Business, BusinessUser } from '../models/user.model';
import { CARD_STATE, COUNTRY, CURRENCY_SECONDARY_DEFAULT_FORMAT } from '../types/enums';

export class Utility {
  static getBackendListField(list: any): Array<any> {
    if (list) {
      if (Array.isArray(list)) {
        return list;
      } else if (typeof list === 'object') {
        return [list];
      }
    }

    return [];
  }

  static roundToDecimals(num: number, decimals = 2): number {
    return parseFloat(num.toFixed(decimals));
  }

  static roundToDecimalsToString(num: number, decimals = 2): string {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  static calculateConsumedPercentage(used?: number, available?: number): number {
    if (used && available) {
      const total = used + available;

      return total === 0 ? 0 : (used * 100) / total;
    } else return 0;
  }

  static sortByDateDesc(stringDate_1: string | Date, stringDate_2: string | Date): number {
    const date_1 = new Date(stringDate_1);
    const date_2 = new Date(stringDate_2);
    if (date_2 < date_1) {
      return -1;
    } else if (date_1 > date_2) {
      return 1;
    } else {
      return 0;
    }
  }

  static sortByActiveFirst(status_1: string, status_2: string): number {
    return status_1 === CARD_STATE.ACTIVE ? -1 : status_2 === CARD_STATE.ACTIVE ? 1 : 0;
  }

  static getCurrencyByCountry(country: string, type: 'primary' | 'secondary'): string {
    return type === 'primary' ? CURRENCY_MAPPER[country] : CURRENCY_SECONDARY_DEFAULT_FORMAT;
  }

  static convertBusinessToCustomerContext(businessInfo: Business | null, businessUserInfo: BusinessUser | null) : ICustomerContext
  {
    var newBusiness: ICustomerContext
    if(businessInfo != null && businessUserInfo != null)
    {
      newBusiness = {
        rppUserId: businessInfo.rpp_business_id,
        userId: businessUserInfo.external_id,
        country: COUNTRY.CO,
        email: businessInfo.email,
        name: businessInfo.name,
        lastName: businessUserInfo.name
      }
    } else {
      newBusiness = {
        rppUserId: '',
        userId: '',
        country: COUNTRY.CO,
        email: '',
        name: '',
        lastName: ''
      }
    }
    return newBusiness;
  }
}
